import { gql } from '@apollo/client';

export default gql`
  subscription putAllNotificationsReadStatusSubscription($userId: String!) {
    putAllNotificationsReadStatusSubscription(userId: $userId) {
      readStatus
    }
  }
`;
